import { SettingType, SettingsProvider, Audience } from '@fluidx/office-fluid-types';
import { getSetting } from './getSetting';

// This is the name of the FluidExperiences team in the Fluid ECS account.
const fluidExperiencesEcsTeamName = 'FluidExperiences';

export let audience: Audience;
export let settingsProvider: SettingsProvider;

export function registerAudience(hostAudience: Audience): void {
  audience = hostAudience;
}

export function registerSettingsProvider(hostSettingsProvider: SettingsProvider): void {
  settingsProvider = hostSettingsProvider;
}

/**
 * Reading a setting from the FluidExperiences ECS Account using the parameter `settingsProvider`.
 * Use `getSetting` if setting is not intended to be stored in ECS.
 * Note: `getSetting` is the fallback mechanism whenever the settingsProvider is `undefined`.
 * @param settingName Name of the setting to retrieve.
 * @param defaultValue Default value to be returned whenever there are no overrides or the setting is not found.
 * @param settingsProvider SettingsProvider used to get the setting from ECS.
 * @returns The setting's value.
 */
export function getFluidExperiencesSetting<T extends SettingType>(
  settingName: string,
  defaultValue: T,
  settingsProvider: SettingsProvider | undefined
): T {
  if (settingsProvider) {
    return settingsProvider.getSetting(settingName, defaultValue, fluidExperiencesEcsTeamName);
  }

  // Use this API whenever the settingsProvider is undefined or the setting is not ecsEnabled.
  return getSetting(settingName, defaultValue);
}
